import axios from 'axios';
import {
  USERS,
  PERMISSIONS,
  ROLES,
  COMPONENT,
  MINISTRIES,
  STATE_MASTER,
  DISTRICT_MASTER,
  ULB_MASTER,
  BLOCK_MASTER,
  EVENTS,
  MINISTRY_UNIT_MASTER,
  MINISTRY_DEPARTMENT_MASTER,
  USERS_DETAILS,
  EVENT_MEDIA,
  Event_CATEGORY,
  EVENT_TYPE,
  CITY_REPORTS,
  EVENT_THEME_MASTER,
  EVENT_HEADING_MASTER,
  EVENT_NAME_MASTER,
  BLOCKS_GP_MASTER,
  GP_VILLAGE_MASTER,
  SBM,
  TWEETS,
  CITIZEN_TESTIMONIAL,
  INSTAGRAM,
  EVENT_HGT_HGS,
  REPORT_EVENTS,
} from './collectionConstants';
import firebase, { db } from './index';
import {
  collection,
  getDocs,
  where,
  query,
  getDoc,
  doc,
  limit,
  startAfter,
  getCountFromServer,
  orderBy,
} from 'firebase/firestore';
import { getUserProfileByIdApi } from '../api';

// Re-export simplified token management
export { getCurrentToken, getAllTokens as getCurrentTokens } from '../utils/tokenManager';

export const getUserByID = async (id) => {
  // Previous Firebase implementation
  // const querySnapshot = await getDocs(query(collection(db, USERS), where('user_id', '==', id)));
  // let userRecord;
  // querySnapshot.forEach((doc) => {
  //   userRecord = doc.data();
  //   userRecord.doc_id = doc.id;
  // });
  // return userRecord;

  // New API implementation
  try {
    // Import API function dynamically to avoid circular dependency
    const { getUserProfileByIdApi } = await import('../api');

    const response = await getUserProfileByIdApi(id);

    if (response?.data?.data) {
      const userData = response.data.data;
      // Format response to match Firebase structure
      return {
        ...userData,
        doc_id: userData.id || userData.user_id, // Ensure doc_id is set for compatibility
      };
    } else {
      console.log(' No data in getUserProfileByIdApi response');
      return null;
    }
  } catch (error) {
    console.error('getUserByID API error:', error);
    return null;
  }
};

// export const getUserByUsername = async (id) => {
//   const querySnapshot = await getDocs(
//     query(collection(db, USERS_DETAILS), where('user_name', '==', id)),
//   );
//   let userRecord;
//   querySnapshot.forEach((doc) => {
//     userRecord = doc.data();
//     userRecord.doc_id = doc.id;
//   });
//   return userRecord;
// };

export const getPermissionsByRoleID = async (roleID) => {
  try {
    const filters = { role_id: roleID };
    const response = await axios.get(
      `genericGetApi?tableName=${PERMISSIONS}&filters=${encodeURIComponent(
        JSON.stringify(filters)
      )}`
    );

    if (response.data.success && response.data.data.count > 0) {
      const permissionData = response.data.data.data[0];
      return {
        ...permissionData,
        doc_id: permissionData.id,
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching permissions by role ID:', error);
    return null;
  }

  // const querySnapshot1 = await getDocs(
  //   query(collection(db, PERMISSIONS), where('role_id', '==', roleID)),
  // );
  // let data;
  // querySnapshot1.forEach((doc) => {
  //   data = doc.data();
  //   data.doc_id = doc.id;
  // });
  // return data;
};

export const getAllRoles = async () => {
  try {
    const response = await axios.get('getRoles');
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching Roles:', error);
    return [];
  }
  // const querySnapshot = await getDocs(collection(db, ROLES));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getRoleByName = async (name) => {
  try {
    const response = await axios.get(`getRoles?role_name=${name}`);
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
    }));

    const roleObject = formattedData[0] || null;
    return roleObject;
  } catch (error) {
    console.error('Error fetching Role by name:', error);
    return null;
  }

  // const querySnapshot = await getDocs(query(collection(db, ROLES), where('role_name', '==', name)));
  // let data;
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data = newdata;
  // });
  // console.log(data, 'data from firebase');
  // return data;
};

export const getAllCityReports = async () => {
  const querySnapshot = await getDocs(collection(db, CITY_REPORTS));
  let report = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    report.push(newdata);
  });
  return report;
};

export const getAllComponents = async () => {
  try {
    const response = await axios.get(`genericGetApi?tableName=${COMPONENT}`);

    if (response.data.success && response.data.data.count > 0) {
      const componentsData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return componentsData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching components:', error);
    return [];
  }

  // const querySnapshot = await getDocs(collection(db, COMPONENT));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getAllUsers = async (lastDoc, pageSize) => {
  try {
    // Import the API function
    const { getAllUsersApi } = await import('../api');

    // Call the API with lastDoc as lastEvaluatedKey
    const response = await getAllUsersApi(lastDoc, pageSize);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id, // Use id as doc_id
      }));

      // Return structure matching Firebase: {data, lastDoc}
      //
      // hasMore comes straight from the API, which derives it from DynamoDB's
      // LastEvaluatedKey. Surfaced so the caller can page on it instead of
      // inferring the end of the list from `data.length < pageSize` -- that
      // heuristic hides every remaining user the moment a filtered page comes
      // back short, which getAllUsersByKey can do.
      return {
        data: formattedData,
        lastDoc: apiData.lastEvaluatedKey || null,
        hasMore: !!apiData.hasMore,
      };
    } else {
      return { data: [], lastDoc: null, hasMore: false };
    }
  } catch (error) {
    console.error('Error in getAllUsers API call:', error);
    return { data: [], lastDoc: null, hasMore: false };
  }

  // FIREBASE FALLBACK (COMMENTED OUT)
  // let usersSnapshot = query(collection(db, USERS_DETAILS), limit(pageSize));
  // if (lastDoc) {
  //   usersSnapshot = query(collection(db, USERS_DETAILS), startAfter(lastDoc), limit(pageSize));
  // }
  // const querySnapshot = await getDocs(usersSnapshot);
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
};

export const getAllUsersCount = async () => {
  //  try {
  //     const response = await axios.get(`genericGetApi?tableName=${USERS}&count=true`);
  //     if (response.data.success) {
  //       return response.data.data.count;
  //     } else {
  //       return 0;
  //     }
  //   } catch (error) {
  //     console.error('Error fetching all user count:', error);
  //     return 0;
  //   }

  const countSnapshot = await getCountFromServer(collection(db, USERS));
  const totalUsersCount = countSnapshot.data().count;

  return totalUsersCount;
};

export const getSBMCount = async () => {
  try {
    const response = await axios.get(`genericGetApi?tableName=${SBM}&count=true`);
    if (response.data.success) {
      return response.data.data.count;
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching SBM count:', error);
    return 0;
  }
  // const countSnapshot = await getCountFromServer(collection(db, SBM));
  // const totalUsersCount = countSnapshot.data().count;
  // return totalUsersCount;
};

export const getFilterCount = async (filterConditions) => {
  let countQuery = collection(db, USERS);
  filterConditions.forEach((condition) => {
    countQuery = query(countQuery, where(condition.field, condition.operator, condition.value));
  });

  const countSnapshot = await getCountFromServer(countQuery);
  const totalUsersCount = countSnapshot.data().count;
  return totalUsersCount;
};

export const getEventFilterCount = async (filterConditions) => {
  let countQuery = collection(db, EVENTS);
  filterConditions.forEach((condition) => {
    countQuery = query(countQuery, where(condition.field, condition.operator, condition.value));
  });

  const countSnapshot = await getCountFromServer(countQuery);
  const totalEvents = countSnapshot.data().count;
  return totalEvents;
};

export const getAllUsersByKey = async (lastDoc, pageSize, key, value) => {
  // let userQuery = query(collection(db, USERS_DETAILS), where(key, '==', value), limit(pageSize));

  // if (lastDoc) {
  //   userQuery = query(
  //     collection(db, USERS_DETAILS),
  //     where(key, '==', value),
  //     startAfter(lastDoc),
  //     limit(pageSize),
  //   );
  // }

  // const querySnapshot = await getDocs(userQuery);

  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });

  // return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };

  // Import the API function
  const { getAllUsersByKeyApi } = await import('../api/index');

  try {
    // Call the new API instead of Firebase
    const response = await getAllUsersByKeyApi(key, value, pageSize, lastDoc);

    // Transform API response to match expected format
    return {
      data: response.data.data || [],
      lastDoc: response.data.lastEvaluatedKey || null,
      hasMore: response.data.hasMore || false,
      count: response.data.count || 0,
    };
  } catch (err) {
    console.error('Error fetching users by key:', err);
    throw err;
  }
};

export const getAllMinistries = async () => {
  try {
    const response = await axios.get('getMinistryData?action=getMinistries');
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
      ministry_code: Number(item.ministry_code),
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching Ministries:', error);
    return [];
  }

  // const querySnapshot = await getDocs(collection(db, MINISTRIES));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getAllSBMList = async () => {
  try {
    const response = await axios.get(`genericGetApi?tableName=${SBM}`);

    if (response.data.success && response.data.data.count > 0) {
      const sbmData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return sbmData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching SBM list:', error);
    return [];
  }

  // const querySnapshot = await getDocs(collection(db, SBM));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // console.log(data, 'sbmlist firebase');
  // return data;
};

export const getAllTestimonialList = async () => {
  try {
    const response = await axios.get(`genericGetApi?tableName=${CITIZEN_TESTIMONIAL}`);

    if (response.data.success && response.data.data.count > 0) {
      const testimonialData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return testimonialData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching testimonial list:', error);
    return [];
  }

  // const querySnapshot = await getDocs(collection(db, CITIZEN_TESTIMONIAL));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getSBMListByEmail = async (email) => {
  try {
    const filters = { created_by_email: email };
    const response = await axios.get(
      `genericGetApi?tableName=${SBM}&filters=${encodeURIComponent(JSON.stringify(filters))}`
    );
    if (response.data.success && response.data.data.count > 0) {
      const sbmData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return sbmData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching SBM list by email:', error);
    return [];
  }

  // const q = query(collection(db, SBM), where('created_by_email', '==', email));

  // const querySnapshot = await getDocs(q);
  // let data = [];

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getTestimonialListByEmail = async (email) => {
  try {
    const filters = { created_by_email: email };
    const response = await axios.get(
      `genericGetApi?tableName=${CITIZEN_TESTIMONIAL}&filters=${encodeURIComponent(
        JSON.stringify(filters)
      )}`
    );

    if (response.data.success && response.data.data.count > 0) {
      const testimonialData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return testimonialData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching testimonial list by email:', error);
    return [];
  }

  // const q = query(collection(db, CITIZEN_TESTIMONIAL), where('created_by_email', '==', email));

  // const querySnapshot = await getDocs(q);
  // let data = [];

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // console.log(data, 'firebase response');
  // return data;
};

export const getEventMediaBySBMId = async (sbm_id) => {
  const q = query(collection(db, EVENT_MEDIA), where('sbm_id', '==', sbm_id));
  const querySnapshot = await getDocs(q);
  let data = [];

  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });
  return data;
};

// export const getAllEventCategories = async () => {
//   const querySnapshot = await getDocs(collection(db, Event_CATEGORY));
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

export const getAllEventTheme = async () => {
  try {
    const response = await axios.get(`genericGetApi?tableName=${EVENT_THEME_MASTER}`);

    if (response.data.success && response.data.data.count > 0) {
      const eventThemeData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));

      return eventThemeData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching event theme data:', error);
    return [];
  }

  // const querySnapshot = await getDocs(collection(db, EVENT_THEME_MASTER));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getAllEventHeadings = async (themeId) => {
  try {
    const filters = { event_theme_id: themeId };
    const response = await axios.get(
      `genericGetApi?tableName=${EVENT_HEADING_MASTER}&filters=${encodeURIComponent(
        JSON.stringify(filters)
      )}`
    );

    if (response.data.success && response.data.data.count > 0) {
      const eventHeadingData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return eventHeadingData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching event headings:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, EVENT_HEADING_MASTER), where('event_theme_id', '==', themeId)),
  // );
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getAllEventName = async (headingId) => {
  try {
    const filters = { event_heading_id: headingId };
    const response = await axios.get(
      `genericGetApi?tableName=${EVENT_NAME_MASTER}&filters=${encodeURIComponent(
        JSON.stringify(filters)
      )}`
    );

    if (response.data.success && response.data.data.count > 0) {
      const eventNameData = response.data.data.data.map((item) => ({
        ...item,
        doc_id: item.id,
      }));
      return eventNameData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching event names:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, EVENT_NAME_MASTER), where('event_heading_id', '==', headingId)),
  // );
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getAllStates = async () => {
  try {
    const response = await axios.get('getLgd?action=getStates');
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching states:', error);
    return [];
  }
  // const querySnapshot = await getDocs(collection(db, STATE_MASTER));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

/**
 * Districts left out of the district dropdown, by state code (7 = Delhi).
 */
const HIDDEN_DISTRICTS_BY_STATE = {
  7: new Set([77, 78, 80, 81, 82, 85, 670, 794, 795, 796]),
};

/**
 * Districts for a state.
 *
 * `eventYear` picks which master answers: 2026 (or omitted) reads the current
 * list, an earlier campaign year reads the one those events were filed
 * against. Report screens pass the year of the tab being viewed; data-entry
 * screens pass nothing and always get the current list.
 */
export const getDistrictsByStateCode = async (stateCode, eventYear) => {
  try {
    const yearParam =
      eventYear === undefined || eventYear === null || eventYear === ''
        ? ''
        : `&event_year=${eventYear}`;
    const response = await axios.get(
      `getLgd?action=getDistricts&state_code=${stateCode}${yearParam}`
    );
    const districtData = response.data?.data?.data || [];

    const seen = new Set();
    const hidden = HIDDEN_DISTRICTS_BY_STATE[Number(stateCode)];

    const formattedData = districtData
      .filter((item) => {
        if (hidden && hidden.has(Number(item.district_code))) return false;
        if (!seen.has(item.district_code)) {
          seen.add(item.district_code);
          return true;
        }
        return false;
      })
      .map((item) => ({
        ...item,
        doc_id: item.id,
      }));

    return formattedData;
  } catch (error) {
    console.error('Error fetching districts:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, DISTRICT_MASTER), where('state_code', '==', stateCode)),
  // );
  // let data = [];
  // const seen = new Set();

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Remove duplicates by district_code
  //   if (!seen.has(newdata.district_code)) {
  //     seen.add(newdata.district_code);
  //     data.push(newdata);
  //   }
  // });
  // return data;
};

export const getMinistryDepartmentsByMinistryCode = async (ministryCode) => {
  try {
    const response = await axios.get(
      `getMinistryData?action=getDepartments&ministry_code=${ministryCode}`
    );
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching ministry departments:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, MINISTRY_DEPARTMENT_MASTER), where('ministry_code', '==', ministryCode)),
  // );
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

export const getMinistrySubUnitByMinistryDepartmentCode = async (departmentCode) => {
  try {
    const response = await axios.get(
      `getMinistryData?action=getUnits&ministry_department_code=${departmentCode}`
    );
    const formattedData = response.data.data.data.map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching ministry units:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(
  //     collection(db, MINISTRY_UNIT_MASTER),
  //     where('ministry_department_code', '==', departmentCode),
  //   ),
  // );
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
};

/**
 * ULBs for a district. See getDistrictsByStateCode for `eventYear` -- the two
 * must be called with the same year, since a district code only resolves
 * against the master it came from.
 */
export const getULBsByDistrictCode = async (districtCode, eventYear) => {
  try {
    const yearParam =
      eventYear === undefined || eventYear === null || eventYear === ''
        ? ''
        : `&event_year=${eventYear}`;
    const response = await axios.get(
      `getLgd?action=getUrbanLocalBodies&district_code=${districtCode}${yearParam}`
    );
    const ULBData = response.data.data.data;
    const seen = new Set();
    const formattedData = ULBData.filter((item) => {
      if (!seen.has(item.ulb_code)) {
        seen.add(item.ulb_code);
        return true;
      }
      return false;
    }).map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching ULBs:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, ULB_MASTER), where('district_code', '==', districtCode)),
  // );
  // let data = [];
  // const seen = new Set();

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Remove duplicates by ulb_code
  //   if (!seen.has(newdata.ulb_code)) {
  //     seen.add(newdata.ulb_code);
  //     data.push(newdata);
  //   }
  // });
  // return data;
};

export const getBlocksByDistrictCode = async (districtCode) => {
  try {
    const response = await axios.get(`getLgd?action=getBlocks&district_code=${districtCode}`);
    const blockData = response.data.data.data;
    const seen = new Set();
    const formattedData = blockData
      .filter((item) => {
        if (!seen.has(item.block_code)) {
          seen.add(item.block_code);
          return true;
        }
        return false;
      })
      .map((item) => ({
        ...item,
        doc_id: item.id,
      }));

    return formattedData;
  } catch (error) {
    console.error('Error fetching blocks:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, BLOCK_MASTER), where('district_code', '==', districtCode)),
  // );
  // let data = [];
  // const seen = new Set();

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Remove duplicates by block_code
  //   if (!seen.has(newdata.block_code)) {
  //     seen.add(newdata.block_code);
  //     data.push(newdata);
  //   }
  // });
  // return data;
};

export const getGPsByBlockCode = async (blockCode) => {
  try {
    const response = await axios.get(`getLgd?action=getGramPanchayats&block_code=${blockCode}`);
    const GPData = response.data.data.data;
    const seen = new Set();
    const formattedData = GPData.filter((item) => {
      if (!seen.has(item.gp_code)) {
        seen.add(item.gp_code);
        return true;
      }
      return false;
    }).map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching GPs:', error);
    return [];
  }
  // const querySnapshot = await getDocs(
  //   query(collection(db, BLOCKS_GP_MASTER), where('block_code', '==', blockCode)),
  // );
  // let data = [];
  // const seen = new Set();

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Remove duplicates by gp_code
  //   if (!seen.has(newdata.gp_code)) {
  //     seen.add(newdata.gp_code);
  //     data.push(newdata);
  //   }
  // });

  // return data;
};

export const getVillagesByGPCode = async (gpCode) => {
  try {
    const response = await axios.get(`getLgd?action=getVillages&gp_code=${gpCode}`);
    const VillageData = response.data.data.data;
    const seen = new Set();
    const formattedData = VillageData.filter((item) => {
      if (!seen.has(item.village_code)) {
        seen.add(item.village_code);
        return true;
      }
      return false;
    }).map((item) => ({
      ...item,
      doc_id: item.id,
    }));
    return formattedData;
  } catch (error) {
    console.error('Error fetching Villages:', error);
    return [];
  }

  // const querySnapshot = await getDocs(
  //   query(collection(db, GP_VILLAGE_MASTER), where('gp_code', '==', gpCode)),
  // );
  // let data = [];
  // const seen = new Set();

  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Remove duplicates by village_code
  //   if (!seen.has(newdata.village_code)) {
  //     seen.add(newdata.village_code);
  //     data.push(newdata);
  //   }
  // });
  // return data;
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getUserByUserName = async (userName) => {
//   const querySnapshot = await getDocs(
//     query(collection(db, USERS_DETAILS), where('user_name', '==', userName)),
//   );
//   const data = [];
//   querySnapshot.docs.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   console.log(data);
//   return data;
// };

// NEW: API implementation
export const getUserByPhone = async (phone) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getUserByPhoneApi } = await import('../api');

    const response = await getUserByPhoneApi(phone);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error in getUserByPhone API call:', error);
    return [];
  }
};

// NEW: API implementation
export const getUserByUserName = async (userName) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getUserByUserNameApi } = await import('../api');

    const response = await getUserByUserNameApi(userName);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error in getUserByUserName API call:', error);
    return [];
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getUserByUserId = async (id) => {
//   const querySnapshot = await getDocs(query(collection(db, USERS), where('user_name', '==', id)));
//   let data;
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data = newdata;
//   });
//   console.log("called getUserByUserId with",id,data)
//   return data;
// };

// NEW: API implementation
export const getUserByUserId = async (id) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getUserByUserIdApi } = await import('../api');

    const response = await getUserByUserIdApi(id);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let userData;
      if (apiData.data) {
        // Nested data structure
        userData = apiData.data;
      } else if (typeof apiData === 'object' && !Array.isArray(apiData)) {
        // Direct object response
        userData = apiData;
      } else {
        userData = null;
      }

      // Format to match Firebase structure
      if (userData) {
        return {
          ...userData,
          doc_id: userData.id || userData.user_id || userData.doc_id,
        };
      }

      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error in getUserByUserId API call:', error);
    return null;
  }
};

export const getAllEvents = async (lastDoc = null, pageSize = 1) => {
  let eventQuery = query(collection(db, EVENTS), limit(pageSize));

  if (lastDoc) {
    eventQuery = query(collection(db, EVENTS), startAfter(lastDoc), limit(pageSize));
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllEventsByKey = async (lastDoc = null, pageSize = 1, key, value) => {
//   let eventQuery = query(
//     collection(db, EVENTS),
//     where(key, '==', value),
//     where('event_name_id', '==', 34),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, EVENTS),
//       where(key, '==', value),
//       where('event_name_id', '==', 34),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     // Apply filtering logic based on event_year and event_completed
//     if (!newdata.event_year) {
//       // For non-2025 events, only show if event_completed is false
//       if (newdata.event_completed === false) {
//         data.push(newdata);
//       }
//     } else {
//       // For 2025 events, show all regardless of completion status
//       data.push(newdata);
//     }
//   });

//   return { data, lastDoc: querySnapshot.docs[querySnapshot?.docs?.length - 1] };
// };

// NEW: API implementation
export const getAllEventsByKey = async (lastDoc = null, pageSize = 25, key, value, page = 1) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getAllEventsByKeyApi } = await import('../api');

    const response = await getAllEventsByKeyApi(lastDoc, pageSize, key, value, page);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
        pagination: apiData.pagination, // Pass through new pagination info
      };
    } else {
      console.log(' No data in getAllEventsByKey API response');
      return { data: [], lastDoc: null, pagination: null };
    }
  } catch (error) {
    console.error(' Error in getAllEventsByKey API call:', error);
    return { data: [], lastDoc: null, pagination: null };
  }
};

export const getAllCPSEventsByKey = async (lastDoc = null, pageSize = 1, key, value) => {
  let eventQuery = query(
    collection(db, EVENTS),
    where(key, '==', value),
    where('event_theme_id', '==', 7),
    limit(pageSize)
  );

  if (lastDoc) {
    eventQuery = query(
      collection(db, EVENTS),
      where(key, '==', value),
      where('event_theme_id', '==', 7),
      startAfter(lastDoc),
      limit(pageSize)
    );
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return { data, lastDoc: querySnapshot.docs[querySnapshot?.docs?.length - 1] };
};

// Cache for collection media data
let cachedMediaData = null;
let currentOffset = 0;

export const getCollectionMedia = async (lastDoc = null, pageSize = 100) => {
  try {
    // Reset offset if this is a fresh call (no lastDoc means start from beginning)
    if (!lastDoc) {
      currentOffset = 0;
      cachedMediaData = null; // Clear cache on fresh call
    }

    // If we don't have cached data, fetch it
    if (!cachedMediaData) {
      const filters = { ministry_unit_code: 159001000 };
      const response = await axios.get(
        `genericGetApi?tableName=landing_page_images_ministry_wise&filters=${encodeURIComponent(
          JSON.stringify(filters)
        )}`
      );

      if (response.data.success && response.data.data.count > 0) {
        cachedMediaData = response.data.data.data.map((item) => ({
          ...item,
          doc_id: item.id,
        }));
      } else {
        return { data: [], lastDoc: null };
      }
    }

    // Implement client-side pagination using cached data
    const paginatedData = cachedMediaData.slice(currentOffset, currentOffset + pageSize);

    // Update offset for next call
    const nextOffset = currentOffset + pageSize;
    const hasMore = nextOffset < cachedMediaData.length;

    // Increment offset for next pagination call
    currentOffset = nextOffset;

    return {
      data: paginatedData,
      lastDoc: hasMore ? { hasMore: true, offset: nextOffset } : null, // Mock lastDoc for pagination
    };
  } catch (error) {
    console.error('Error fetching collection media:', error);
    return { data: [], lastDoc: null };
  }

  // let eventQuery = query(
  //   collection(db, 'landing_page_images_ministry_wise'),
  //   where('ministry_unit_code', '==', 159001000),
  //   limit(pageSize),
  // );

  // if (lastDoc) {
  //   eventQuery = query(
  //     collection(db, 'landing_page_images_ministry_wise'),
  //     where('ministry_unit_code', '==', 159001000),
  //     startAfter(lastDoc),
  //     limit(pageSize),
  //   );
  // }

  // const querySnapshot = await getDocs(eventQuery);
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });

  // return { data, lastDoc: querySnapshot.docs[querySnapshot?.docs?.length - 1] };
};

export const getAllAdoptedEvents = async (userId) => {
  let eventQuery = query(
    collection(db, EVENTS),
    where('status', '==', 'APPROVED'),
    where('event_type', '==', 'PARTNER_ADOPT_CTU'),
    where('user_id', '==', userId)
  );

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return data;
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllEventsByQuery = async (
//   lastDoc = null,
//   pageSize = 1,
//   queryParams = {},
//   conditionAllowed,
//   removeCondition = false,
// ) => {
//   let eventQuery;
//   if (removeCondition) {
//     eventQuery = query(collection(db, EVENTS));
//   } else {
//     eventQuery = query(collection(db, EVENTS), where('event_name_id', '==', 34));
//   }

//   for (let key in queryParams) {
//     const value = queryParams[key];
//     if (key && value !== undefined && value !== null && value !== '') {
//       if (key === 'exclude_creator_email') {
//         // Use != operator for excluding creator email
//         eventQuery = query(eventQuery, where('creator_email', '!=', value));
//       } else {
//         eventQuery = query(eventQuery, where(key, '==', value));
//       }
//     }
//   }
//   if (lastDoc) {
//     eventQuery = query(eventQuery, startAfter(lastDoc), limit(pageSize));
//   } else {
//     eventQuery = query(eventQuery, limit(pageSize));
//   }

//   const querySnapshot = await getDocs(eventQuery);

//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;

//     if (conditionAllowed) {
//       // Apply filtering logic based on event_year and event_completed
//       if (newdata.event_year !== '2025') {
//         // For non-2025 events, only show if event_completed is false
//         if (newdata.event_completed === false) {
//           data.push(newdata);
//         }
//       } else {
//         // For 2025 events, show all regardless of completion status
//         data.push(newdata);
//       }
//     } else {
//       data.push(newdata);
//     }
//   });

//   // Return the data and the last document for pagination
//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getAllEventsByQuery = async (
  lastDoc = null,
  pageSize = 25,
  queryParams = {},
  conditionAllowed,
  removeCondition = false,
  page = 1
) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getAllEventsByQueryApi } = await import('../api');

    const response = await getAllEventsByQueryApi(
      lastDoc,
      pageSize,
      queryParams,
      conditionAllowed,
      removeCondition,
      page
    );

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
        pagination: apiData.pagination, // Pass through new pagination info
      };
    } else {
      console.log(' No data in getAllEventsByQuery API response');
      return { data: [], lastDoc: null, pagination: null };
    }
  } catch (error) {
    console.error(' Error in getAllEventsByQuery API call:', error);
    return { data: [], lastDoc: null, pagination: null };
  }
};

export const getAllEventsByQueryOther = async (
  lastDoc = null,
  pageSize = 1,
  queryParams = {},
  conditionAllowed
) => {
  const { getAllEventsByQueryOtherApi } = await import('../api');

  const response = await getAllEventsByQueryOtherApi(
    lastDoc,
    pageSize,
    queryParams,
    conditionAllowed
  );

  const data = response.data.data.map((event) => ({
    ...event,
    doc_id: event.event_id,
  }));

  return {
    data,
    lastDoc: response.data.lastEvaluatedKey || null,
  };
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllCPSEventsByQuery = async (lastDoc = null, pageSize = 1, queryParams = {}) => {
//   let eventQuery = query(collection(db, EVENTS), where('event_theme_id', '==', 7));

//   for (let key in queryParams) {
//     const value = queryParams[key];
//     if (key && value !== undefined && value !== null && value !== '') {
//       if (key === 'exclude_creator_email') {
//         eventQuery = query(eventQuery, where('creator_email', '!=', value));
//       } else {
//         eventQuery = query(eventQuery, where(key, '==', value));
//       }
//     }
//   }
//   if (lastDoc) {
//     eventQuery = query(eventQuery, startAfter(lastDoc), limit(pageSize));
//   } else {
//     eventQuery = query(eventQuery, limit(pageSize));
//   }

//   const querySnapshot = await getDocs(eventQuery);

//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;

//     data.push(newdata);
//   });

//   // Return the data and the last document for pagination
//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getAllCPSEventsByQuery = async (lastDoc = null, pageSize = 25, queryParams = {}) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getAllCPSEventsByQueryApi } = await import('../api');

    const response = await getAllCPSEventsByQueryApi(lastDoc, pageSize, queryParams);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log(' No data in getAllCPSEventsByQuery API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error(' Error in getAllCPSEventsByQuery API call:', error);
    return { data: [], lastDoc: null };
  }
};

export const getEventsBySearch = async (userId, key, value, eventYear) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getEventsBySearchApi } = await import('../api');
    const response = await getEventsBySearchApi(userId, key, value, eventYear);

    if (response?.status === 200 && response?.data) {
      // The API applies the year logic, but only against the year it is GIVEN --
      // omit eventYear and it assumes 2025. Callers must pass the year they are
      // displaying.
      return response.data;
    }

    return [];
  } catch (error) {
    console.error('Error in getEventsBySearch:', error);
    return [];
  }

  // FIREBASE IMPLEMENTATION - COMMENTED OUT
  // let eventQuery;
  // if (!key) {
  //   eventQuery = query(
  //     collection(db, EVENTS),
  //     where('creator_uid', '==', userId),
  //     where('event_name_id', '==', 34),
  //   );
  // } else {
  //   eventQuery = query(
  //     collection(db, EVENTS),
  //     where('creator_uid', '==', userId),
  //     where('event_name_id', '==', 34),
  //     where(key, '==', value),
  //   );
  // }

  // const querySnapshot = await getDocs(eventQuery);
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;

  //   // Apply filtering logic based on event_year and event_completed
  //   if (newdata.event_year !== '2025') {
  //     // For non-2025 events, only show if event_completed is false
  //     if (newdata.event_completed === false) {
  //       data.push(newdata);
  //     }
  //   } else {
  //     // For 2025 events, show all regardless of completion status
  //     data.push(newdata);
  //   }
  // });

  // return data;
};

export const getHGTHGSEventsBySearch = async (userId, key, value) => {
  let eventQuery;
  if (!key) {
    eventQuery = query(
      collection(db, EVENTS),
      where('creator_uid', '==', userId),
      where('event_type', '==', 'DAILY_HGT_HGS')
    );
  } else {
    eventQuery = query(
      collection(db, EVENTS),
      where('creator_uid', '==', userId),
      where(key, '==', value),
      where('event_type', '==', 'DAILY_HGT_HGS')
    );
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return data;
};

export const getHighlightActivityEventsBySearch = async (userId, key, value) => {
  let eventQuery;
  if (!key) {
    eventQuery = query(
      collection(db, EVENTS),
      where('creator_uid', '==', userId),
      where('event_type', '==', 'HIGHLIGHT_ACTIVITY')
    );
  } else {
    eventQuery = query(
      collection(db, EVENTS),
      where('creator_uid', '==', userId),
      where(key, '==', value),
      where('event_type', '==', 'HIGHLIGHT_ACTIVITY')
    );
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return data;
};

export const getEventsByDistrictCodeAndEventNameID = async (
  districtCode,
  eventNameID,
  lastDoc = null,
  pageSize = 1
) => {
  let eventQuery = query(
    collection(db, EVENTS),
    where('district_code', '==', districtCode),
    where('event_name_id', '==', eventNameID),
    limit(pageSize)
  );

  if (lastDoc) {
    eventQuery = query(
      collection(db, EVENTS),
      where('district_code', '==', districtCode),
      where('event_name_id', '==', eventNameID),
      startAfter(lastDoc),
      limit(pageSize)
    );
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllEventsToApprove = async (lastDoc = null, pageSize = 1, email) => {
//   let eventQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('creator_email', '==', email),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, 'join_adopt_ctu'),
//       where('status', '==', 'REQUESTED'),
//       where('creator_email', '==', email),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });

//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getAllEventsToApprove = async (lastDoc = null, pageSize = 25, email) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getAllEventsToApproveApi } = await import('../api');

    const response = await getAllEventsToApproveApi(email, lastDoc, pageSize);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log('No data in API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error('Error in getAllEventsToApprove API call:', error);
    return { data: [], lastDoc: null };
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllEventsToApproveForAdmin = async (lastDoc = null, pageSize = 1) => {
//   let eventQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, 'join_adopt_ctu'),
//       where('status', '==', 'REQUESTED'),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });

//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation for admin
export const getAllEventsToApproveForAdmin = async (lastDoc = null, pageSize = 25) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getAllEventsToApproveForAdminApi } = await import('../api');

    const response = await getAllEventsToApproveForAdminApi(lastDoc, pageSize);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));
      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log('❌ No data in admin API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error('🚨 Error in getAllEventsToApproveForAdmin API call:', error);
    return { data: [], lastDoc: null };
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getJoinAdoptRequestByOrganisationPhone = async (phone) => {
//   const q = query(collection(db, 'join_adopt_ctu'), where('organisation_phone', '==', phone));
//   const querySnapshot = await getDocs(q);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getJoinAdoptRequestByOrganisationPhone = async (phone) => {
  // const q = query(collection(db, 'join_adopt_ctu'), where('organisation_phone', '==', phone));
  //   const querySnapshot = await getDocs(q);
  //   let data = [];
  //   querySnapshot.forEach((doc) => {
  //     let newdata = doc.data();
  //     newdata.doc_id = doc.id;
  //     data.push(newdata);
  //   });
  //   return data;

  try {
    // Import API function dynamically to avoid circular dependency
    const { getJoinAdoptRequestByOrganisationPhoneApi } = await import('../api');
    const response = await getJoinAdoptRequestByOrganisationPhoneApi(phone);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      console.log('❌ No data in phone search API response');
      return [];
    }
  } catch (error) {
    console.error('🚨 Error in getJoinAdoptRequestByOrganisationPhone API call:', error);
    return [];
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getApprovedPartnerRequestByOrganisationPhone = async (phone) => {
//   const q = query(
//     collection(db, USERS_DETAILS),
//     where('organisation_phone', '==', phone),
//     where('isPartnerUserApproved', '==', true),
//   );
//   const querySnapshot = await getDocs(q);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getApprovedPartnerRequestByOrganisationPhone = async (phone) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getApprovedPartnerRequestByOrganisationPhoneApi } = await import('../api');

    const response = await getApprovedPartnerRequestByOrganisationPhoneApi(phone);
    if (response?.data) {
      const apiData = response.data;
      return apiData;
    } else {
      console.log('❌ No data in approved partner search API response');
      return [];
    }
  } catch (error) {
    console.error('🚨 Error in getApprovedPartnerRequestByOrganisationPhone API call:', error);
    return [];
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getPartnerRequestByOrganisationPhone = async (phone) => {
//   const q = query(
//     collection(db, USERS_DETAILS),
//     where('organisation_phone', '==', phone),
//     where('isPartnerUserApproved', '==', false),
//   );
//   const querySnapshot = await getDocs(q);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getPartnerRequestByOrganisationPhone = async (phone) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getPartnerRequestByOrganisationPhoneApi } = await import('../api');

    const response = await getPartnerRequestByOrganisationPhoneApi(phone);

    if (response?.data) {
      const apiData = response.data;
      return apiData;
    } else {
      console.log('❌ No data in partner request search API response');
      return [];
    }
  } catch (error) {
    console.error('🚨 Error in getPartnerRequestByOrganisationPhone API call:', error);
    return [];
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getRequestNumberForOwnedCTU = async (email) => {
//   const countQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('creator_email', '==', email),
//   );
//   const countSnapshot = await getCountFromServer(countQuery);
//   const totalCount = countSnapshot.data().count;
//   return totalCount;
// };

// NEW: API implementation
export const getRequestNumberForOwnedCTU = async (email) => {
  try {
    // Import the API function from index.js
    const { getRequestNumberForOwnedCTUApi } = await import('../api');

    const response = await getRequestNumberForOwnedCTUApi(email);

    if (response?.data !== undefined && response?.data !== null) {
      // API returns the number directly
      const count =
        typeof response.data === 'number' ? response.data : parseInt(response.data) || 0;
      return count;
    } else {
      console.log('❌ No valid count in owned CTU API response');
      return 0;
    }
  } catch (error) {
    console.error('🚨 Error in getRequestNumberForOwnedCTU API call:', error);
    return 0;
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllRequestNumber = async (email) => {
//   const countQuery = query(collection(db, 'join_adopt_ctu'), where('status', '==', 'REQUESTED'));
//   const countSnapshot = await getCountFromServer(countQuery);
//   const totalCount = countSnapshot.data().count;
//   return totalCount;
// };

// NEW: API implementation
export const getAllRequestNumber = async (email) => {
  //  const countQuery = query(collection(db, 'join_adopt_ctu'), where('status', '==', 'REQUESTED'));
  // const countSnapshot = await getCountFromServer(countQuery);
  // const totalCount = countSnapshot.data().count;
  // return totalCount;

  try {
    // Import the API function from index.js
    const { getAllRequestNumberApi } = await import('../api');

    const response = await getAllRequestNumberApi();

    if (response?.data !== undefined && response?.data !== null) {
      // API returns the number directly
      const count =
        typeof response.data === 'number' ? response.data : parseInt(response.data) || 0;
      return count;
    } else {
      console.log('❌ No valid count in API response');
      return 0;
    }
  } catch (error) {
    console.error('🚨 Error in getAllRequestNumber API call:', error);
    return 0;
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getRuralEventsToApprove = async (lastDoc = null, pageSize = 1, districtCode) => {
//   let eventQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('district_code', '==', districtCode),
//     where('location_type', '==', 'RURAL'),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, 'join_adopt_ctu'),
//       where('status', '==', 'REQUESTED'),
//       where('district_code', '==', districtCode),
//       where('location_type', '==', 'RURAL'),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getRuralEventsToApprove = async (lastDoc = null, pageSize = 25, districtCode) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getEventsToApproveByLocationApi } = await import('../api');

    const response = await getEventsToApproveByLocationApi(
      'RURAL',
      districtCode,
      lastDoc,
      pageSize
    );

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log(' No data in rural events API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error(' Error in getRuralEventsToApprove API call:', error);
    return { data: [], lastDoc: null };
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getUrbanEventsToApprove = async (lastDoc = null, pageSize = 1, ulbCode) => {
//   let eventQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('ulb_code', '==', ulbCode),
//     where('location_type', '==', 'URBAN'),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, 'join_adopt_ctu'),
//       where('status', '==', 'REQUESTED'),
//       where('ulb_code', '==', ulbCode),
//       where('location_type', '==', 'URBAN'),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });

//   console.log(data);
//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getUrbanEventsToApprove = async (lastDoc = null, pageSize = 25, ulbCode) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getEventsToApproveByLocationApi } = await import('../api');

    const response = await getEventsToApproveByLocationApi('URBAN', ulbCode, lastDoc, pageSize);

    if (response?.data) {
      const apiData = response.data;

      // Format data to match Firebase structure
      const formattedData = apiData.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id, // Ensure doc_id exists
      }));

      return {
        data: formattedData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log(' No data in urban events API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error(' Error in getUrbanEventsToApprove API call:', error);
    return { data: [], lastDoc: null };
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getRequestNumberForUlbCTU = async (ulbCode) => {
//   const countQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('ulb_code', '==', ulbCode),
//     where('location_type', '==', 'URBAN'),
//   );

//   // Fetch the total count using getCountFromServer
//   const countSnapshot = await getCountFromServer(countQuery);
//   const totalCount = countSnapshot.data().count;
//   return totalCount;
// };

// NEW: API implementation
export const getRequestNumberForUlbCTU = async (ulbCode) => {
  try {
    // Import the API function from index.js
    const { getRequestNumberByLocationApi } = await import('../api');

    const response = await getRequestNumberByLocationApi('URBAN', ulbCode);

    if (response?.data !== undefined && response?.data !== null) {
      // API returns the number directly
      const count =
        typeof response.data === 'number' ? response.data : parseInt(response.data) || 0;
      return count;
    } else {
      console.log('❌ No valid count in ULB CTU API response');
      return 0;
    }
  } catch (error) {
    console.error('🚨 Error in getRequestNumberForUlbCTU API call:', error);
    return 0;
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getRequestNumberForDistrictCTU = async (districtCode) => {
//   const countQuery = query(
//     collection(db, 'join_adopt_ctu'),
//     where('status', '==', 'REQUESTED'),
//     where('district_code', '==', districtCode),
//     where('location_type', '==', 'RURAL'),
//   );

//   // Fetch the total count using getCountFromServer
//   const countSnapshot = await getCountFromServer(countQuery);
//   const totalCount = countSnapshot.data().count;
//   return totalCount;
// };

// NEW: API implementation
export const getRequestNumberForDistrictCTU = async (districtCode) => {
  try {
    // Import the API function from index.js
    const { getRequestNumberByLocationApi } = await import('../api');

    const response = await getRequestNumberByLocationApi('RURAL', districtCode);

    if (response?.data !== undefined && response?.data !== null) {
      // API returns the number directly
      const count =
        typeof response.data === 'number' ? response.data : parseInt(response.data) || 0;
      return count;
    } else {
      console.log('❌ No valid count in District CTU API response');
      return 0;
    }
  } catch (error) {
    console.error('🚨 Error in getRequestNumberForDistrictCTU API call:', error);
    return 0;
  }
};

export const getAllEventsByEventType = async (lastDoc = null, pageSize = 1) => {
  let eventQuery = query(
    collection(db, EVENTS),
    where('event_type', '!=', null),
    where('status', '==', 'REQUESTED'),
    limit(pageSize)
  );

  if (lastDoc) {
    eventQuery = query(
      collection(db, EVENTS),
      where('event_type', '!=', null),
      where('status', '==', 'REQUESTED'),
      startAfter(lastDoc),
      limit(pageSize)
    );
  }

  const querySnapshot = await getDocs(eventQuery);
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });

  return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllEventsByRoleID = async (roleID, lastDoc = null, pageSize = 1) => {
//   let eventQuery = query(
//     collection(db, EVENTS),
//     where('role_id', '==', roleID),
//     where('approved', '==', false),
//     limit(pageSize),
//   );

//   if (lastDoc) {
//     eventQuery = query(
//       collection(db, EVENTS),
//       where('role_id', '==', roleID),
//       where('approved', '==', false),
//       startAfter(lastDoc),
//       limit(pageSize),
//     );
//   }

//   const querySnapshot = await getDocs(eventQuery);
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });

//   return { data, lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1] };
// };

// NEW: API implementation
export const getAllEventsByRoleID = async (roleID, lastDoc = null, pageSize = 1) => {
  try {
    // Import the API function from index.js
    const { getAllEventsByRoleIDApi } = await import('../api');

    const response = await getAllEventsByRoleIDApi(roleID, lastDoc, pageSize);

    if (response?.data) {
      const apiData = response.data;
      return {
        data: apiData,
        lastDoc: apiData.lastDoc || apiData.lastEvaluatedKey || null, // Handle both possible cursor formats
      };
    } else {
      console.log(' No data in events by role ID API response');
      return { data: [], lastDoc: null };
    }
  } catch (error) {
    console.error(' Error in getAllEventsByRoleID API call:', error);
    return { data: [], lastDoc: null };
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getUserDetailsByUserID = async (id) => {
//   const usersSnapshot = await getDocs(
//     query(collection(db, USERS_DETAILS), where('user_id', '==', id)),
//   );
//   let userData = [];
//   usersSnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     userData.push(newdata);
//   });
//   return userData;
// };

export const getUserDetailsByUserID = async (id) => {
  const { getUserDetailsByUserIDApi } = await import('../api');

  const response = await getUserDetailsByUserIDApi(id);

  // API returns array with doc_id already mapped
  return response.data;
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getEventByID = async (id) => {
//   const docRef = doc(db, EVENTS, id);
//   const docSnap = await getDoc(docRef);
//   return docSnap.data();
// };

// NEW: API implementation
export const getEventByID = async (id) => {
  try {
    // Import the API function from index.js
    const { getEventByIDApi } = await import('../api');

    const response = await getEventByIDApi(id);

    if (response?.data) {
      return response.data;
    } else {
      console.log(' No data in event by ID API response');
      return null;
    }
  } catch (error) {
    console.error(' Error in getEventByID API call:', error);
    return null;
  }
};

export const getMediaImages = async (collectionName, visible = true) => {
  // Previous Firebase implementation
  // const mediaQuery = query(collection(db, collectionName), where('visible', '==', true));
  // const querySnapshot = await getDocs(mediaQuery);
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;

  // New API implementation
  try {
    // Build query parameters
    const params = new URLSearchParams({ tableName: collectionName });

    // Only add visible param if it's explicitly set
    if (visible !== null) {
      params.append('visible', visible.toString());
    }

    const response = await axios.get(`getMediaImages?${params.toString()}`, {
      headers: {
        accept: 'application/json',
      },
    });
    if (response?.data) {
      // Format response to match Firebase structure
      return response.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id || item.image_id, // Ensure doc_id is set for compatibility
      }));
    }

    return [];
  } catch (error) {
    console.error('Error fetching media images from API:', error);
    throw error;
  }
};

export const getAllPartnersDetails = async (lastDoc = null, pageSize = 200) => {
  try {
    // Use API implementation
    const { getAllPartnersDetailsApi } = await import('../api');

    // Convert Firebase pagination format to API format
    const lastEvaluatedKey = typeof lastDoc === 'string' ? lastDoc : null;
    const response = await getAllPartnersDetailsApi(false, pageSize, lastEvaluatedKey);

    if (response?.data) {
      // Format data to match Firebase return structure
      // API returns: { userData: [...], lastDoc: "...", hasMore: true, count: 37 }
      const formattedData = response.data.userData.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id,
      }));

      return {
        userData: formattedData,
        lastDoc: response.data.lastDoc || null,
      };
    }
    return { userData: [], lastDoc: null };
  } catch (error) {
    console.error('Error in getAllPartnersDetails:', error);
    return { userData: [], lastDoc: null };
  }

  // Previous Firebase implementation (commented out)
  // let q = query(
  //   collection(db, USERS_DETAILS),
  //   where('role_id', '==', 10),
  //   where('isPartnerUserApproved', '==', false),
  //   limit(pageSize), // Limit the number of documents fetched
  // );

  // // If lastDoc exists, start the next query after it
  // if (lastDoc) {
  //   q = query(q, startAfter(lastDoc), limit(pageSize));
  // }

  // const usersSnapshot = await getDocs(q);
  // let userData = [];

  // usersSnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   userData.push(newdata);
  // });

  // return { userData, lastDoc: usersSnapshot.docs[usersSnapshot.docs.length - 1] };
};

export const getAllApprovedPartnersDetails = async (lastDoc = null, pageSize = 200) => {
  try {
    // Use API implementation for approved partners
    const { getAllPartnersDetailsApi } = await import('../api');

    // Convert Firebase pagination format to API format
    const lastEvaluatedKey = typeof lastDoc === 'string' ? lastDoc : null;
    const response = await getAllPartnersDetailsApi(true, pageSize, lastEvaluatedKey); // approved=true

    if (response?.data) {
      // Format data to match Firebase return structure
      // API returns: { userData: [...], lastDoc: "...", hasMore: true, count: X }
      const formattedData = response.data.userData.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id,
      }));

      return {
        userData: formattedData,
        lastDoc: response.data.lastDoc || null,
      };
    }
    return { userData: [], lastDoc: null };
  } catch (error) {
    console.error('Error in getAllApprovedPartnersDetails:', error);
    return { userData: [], lastDoc: null };
  }

  // Previous Firebase implementation (commented out)
  // let q = query(
  //   collection(db, USERS_DETAILS),
  //   where('role_id', '==', 10),
  //   where('isPartnerUserApproved', '==', true),
  //   limit(pageSize), // Limit the number of documents fetched
  // );

  // // If lastDoc exists, start the next query after it
  // if (lastDoc) {
  //   q = query(q, startAfter(lastDoc), limit(pageSize));
  // }

  // const usersSnapshot = await getDocs(q);
  // let userData = [];

  // usersSnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   userData.push(newdata);
  // });

  // return { userData, lastDoc: usersSnapshot.docs[usersSnapshot.docs.length - 1] };
};

export const getPartnerEventDetails = async (userId) => {
  try {
    // Use API implementation
    const { getPartnerEventDetailsApi } = await import('../api');
    const response = await getPartnerEventDetailsApi(userId);

    if (response?.data) {
      // Format data to match Firebase return structure
      const formattedData = response.data.map((item) => ({
        ...item,
        doc_id: item.id || item.doc_id,
      }));

      return formattedData;
    }
    return [];
  } catch (error) {
    console.error('Error in getPartnerEventDetails:', error);
    return [];
  }

  // Previous Firebase implementation (commented out)
  // const eventSnapshot = await getDocs(
  //   query(collection(db, EVENTS), where('user_id', '==', userId)),
  // );
  // let eventData = [];
  // eventSnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   eventData.push(newdata);
  // });
  // return eventData;
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getMediaByEventIDAndMediaType = async (id, type, date) => {
//   let querySnapshot;
//   if (date) {
//     querySnapshot = await getDocs(
//       query(
//         collection(db, EVENT_MEDIA),
//         where('event_id', '==', id),
//         where('event_media_type', '==', type),
//         where('daily_event_date', '==', date),
//       ),
//     );
//   } else {
//     querySnapshot = await getDocs(
//       query(
//         collection(db, EVENT_MEDIA),
//         where('event_id', '==', id),
//         where('event_media_type', '==', type),
//       ),
//     );
//   }
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getMediaByEventIDAndMediaType = async (id, type, date) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getMediaByEventIDAndMediaTypeApi } = await import('../api');

    const response = await getMediaByEventIDAndMediaTypeApi(id, type, date);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error in getMediaByEventIDAndMediaType API call:', error);
    return [];
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getMediaByTestimonialIDAndMediaType = async (id, type) => {
//   let querySnapshot;
//   querySnapshot = await getDocs(
//     query(
//       collection(db, EVENT_MEDIA),
//       where('testimonial_id', '==', id),
//       where('event_media_type', '==', type),
//     ),
//   );
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getMediaByTestimonialIDAndMediaType = async (id, type) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getMediaByTestimonialIDAndMediaTypeApi } = await import('../api');

    const response = await getMediaByTestimonialIDAndMediaTypeApi(id, type);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error in getMediaByTestimonialIDAndMediaType API call:', error);
    return [];
  }
};

export const getMediaBySbmIDAndMediaType = async (id, type) => {
  let querySnapshot;
  querySnapshot = await getDocs(
    query(
      collection(db, EVENT_MEDIA),
      where('sbm_id', '==', id),
      where('event_media_type', '==', type)
    )
  );
  let data = [];
  querySnapshot.forEach((doc) => {
    let newdata = doc.data();
    newdata.doc_id = doc.id;
    data.push(newdata);
  });
  return data;
};

export const getEventThemeCountById = async (id) => {
  try {
    // Create a reference to the collection (replace 'events' with your collection name)
    const eventsRef = collection(db, 'events');

    // Create a query where theme id matches the provided id
    const q = query(eventsRef, where('event_theme_id', '==', id));

    // Get the count from the server
    const snapshot = await getCountFromServer(q);

    // Return the count
    return snapshot.data().count;
  } catch (error) {
    console.error('Error getting count from server:', error);
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getAllPartners = async () => {
//   const querySnapshot = await getDocs(
//     query(
//       collection(db, USERS),
//       where('role_id', '==', 10),
//       where('isPartnerUserApproved', '==', true),
//     ),
//   );
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

export const getAllPartners = async () => {
  const { getAllPartnersApi } = await import('../api');

  const response = await getAllPartnersApi();

  // API returns array directly with doc_id already mapped
  return response.data;
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getTweetIDs = async () => {
//   const querySnapshot = await getDocs(query(collection(db, TWEETS)));
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getTweetIDs = async () => {
  try {
    const response = await axios.get('getTweetIDs', {
      headers: {
        accept: 'application/json',
      },
    });
    if (response?.data && Array.isArray(response.data)) {
      return response.data;
    }

    return [];
  } catch (error) {
    console.error('Error fetching tweet IDs from API:', error);
    throw error;
  }
};

// COMMENTED OUT: Firebase implementation - replaced with API call
// export const getJoinAdoptRequestById = async (userId, eventId) => {
//   const querySnapshot = await getDocs(
//     query(
//       collection(db, 'join_adopt_ctu'),
//       where('user_id', '==', userId),
//       where('event_id', '==', eventId),
//     ),
//   );
//   let data = [];
//   querySnapshot.forEach((doc) => {
//     let newdata = doc.data();
//     newdata.doc_id = doc.id;
//     data.push(newdata);
//   });
//   return data;
// };

// NEW: API implementation
export const getJoinAdoptRequestById = async (userId, eventId) => {
  try {
    // Import API function dynamically to avoid circular dependency
    const { getJoinAdoptRequestByIdApi } = await import('../api');

    const response = await getJoinAdoptRequestByIdApi(userId, eventId);

    if (response?.data) {
      const apiData = response.data;

      // Handle both possible API response structures
      let dataArray;
      if (Array.isArray(apiData)) {
        // Direct array response
        dataArray = apiData;
      } else if (apiData.data && Array.isArray(apiData.data)) {
        // Nested data structure
        dataArray = apiData.data;
      } else {
        dataArray = [];
      }

      return dataArray;
    } else {
      console.log('No data in join/adopt request by ID API response');
      return [];
    }
  } catch (error) {
    console.error('Error in getJoinAdoptRequestById API call:', error);
    return [];
  }
};

export const getInstaIDs = async () => {
  // const querySnapshot = await getDocs(query(collection(db, INSTAGRAM)));
  // let data = [];
  // querySnapshot.forEach((doc) => {
  //   let newdata = doc.data();
  //   newdata.doc_id = doc.id;
  //   data.push(newdata);
  // });
  // return data;
  try {
    const response = await axios.get('getInstaIDs', {
      headers: {
        accept: 'application/json',
      },
    });
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.log('Error in getInstaIDs api call', error);
    throw error;
  }
};

export const getHgtHgsReports = async (startDate, endDate, stateCode, districtCode) => {
  try {
    const collectionRef = collection(db, EVENT_HGT_HGS);
    let firebaseQuery = query(collectionRef);

    // Add event_type filter (always DAILY_HGT_HGS)
    firebaseQuery = query(firebaseQuery, where('event_type', '==', 'DAILY_HGT_HGS'));

    // Add date range filtering
    if (startDate) {
      firebaseQuery = query(firebaseQuery, where('date', '>=', startDate));
    }
    if (endDate) {
      firebaseQuery = query(firebaseQuery, where('date', '<=', endDate));
    }

    // Add state filtering
    if (stateCode) {
      firebaseQuery = query(firebaseQuery, where('state_code', '==', stateCode));
    }

    // Add district filtering
    if (districtCode) {
      firebaseQuery = query(firebaseQuery, where('district_code', '==', districtCode));
    }

    // Add ordering
    const querySnapshot = await getDocs(firebaseQuery);
    const results = [];
    querySnapshot.forEach((doc) => {
      results.push({ id: doc.id, ...doc.data() });
    });

    return results;
  } catch (error) {
    console.error('Error fetching HGT HGS reports from Firebase:', error);
    throw error;
  }
};

export const getLandingPageDataHGTHGS = async () => {
  try {
    const collectionRef = collection(db, EVENTS);
    const firebaseQuery = query(collectionRef, where('event_type', '==', 'DAILY_HGT_HGS'));
    const querySnapshot = await getDocs(firebaseQuery);

    let totals = {
      cleanliness_drives: 0,
      door_to_door_campaigns: 0,
      gvp_transformed: 0,
      rrr_mobilized: 0,
      shg_participation: 0,
      sup_free_sites: 0,
      post_independence_drives: 0,
    };

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      Object.keys(totals).forEach((field) => {
        if (data[field]) {
          totals[field] += data[field];
        }
      });
    });

    return totals;
  } catch (error) {
    console.error('Error fetching HGT HGS data from Firebase:', error);
    throw error;
  }
};
